import { useState, useEffect } from 'react'
import { FirstScreen, SecondScreen } from '@/components'
import api from '@/lib/api'
import { useOrder } from '@/contexts/OrderContext'
import moment from 'moment'
import { CSSTransition } from 'react-transition-group'
import { useRouter } from 'next/router'
import getWindowWidth from '@/lib/getWindowWidth'

const Home = () => {
    const windowWidth = getWindowWidth()
    const { master, form } = useOrder()
    const [step, setStep] = useState(1)
    const [days, setDays] = useState([])
    const [time, setTime] = useState([])
    const router = useRouter()
    const query = router.query

    const fetchDays = async (date) => {
        form.submit(async () => {
            const { dates } = await api.days({
                master_id: master.id,
                date: moment(date).format('YYYY-MM'),
                services: form.values.services,
            })
            await setDays([...days, ...dates])
        })
    }

    const goToNextStep = async () => {
        const now = new Date()

        if (windowWidth > 768) {
            const [dates1, dates2] = await Promise.all([
                api.days({
                    master_id: master.id,
                    date: moment(now).format('YYYY-MM'),
                    services: form.values.services,
                }),
                api.days({
                    master_id: master.id,
                    date: moment(new Date(now.getFullYear(), now.getMonth() + 1, 1)).format('YYYY-MM'),
                    services: form.values.services,
                }),
            ])
            setDays([...dates1.dates, ...dates2.dates])
        } else {
            fetchDays(now)
        }

        setStep(2)
    }

    const fetchTime = async () => {
        form.submit(async () => {
            const { available_time } = await api.availableTime({
                master_id: master.id,
                date: moment(form.values.date).format('YYYY-MM-DD'),
                services: form.values.services,
            })
            setTime(available_time)
        })
    }

    const sendCode = async () => {
        form.submit(async () => {
            await api.auth.sendCode({
                phone: form.values.phone,
            })
            router.push(
                { pathname: `/masters/web/[id]/code` },
                { pathname: `/masters/web/${query.id}/code` },
                { shallow: false },
            )
        })
    }

    useEffect(() => {
        form.values.date && fetchTime()
    }, [form.values.date])

    return (
        <>
            <CSSTransition in={step === 1} timeout={300} classNames="screen" unmountOnExit>
                <div>
                    <FirstScreen master={master} form={form} onBtnClick={goToNextStep} />
                </div>
            </CSSTransition>
            <CSSTransition in={step === 2} timeout={300} classNames="screen" unmountOnExit>
                <SecondScreen
                    master={master}
                    days={days}
                    time={time}
                    form={form}
                    fetchDays={fetchDays}
                    onBtnClick={sendCode}
                    goToPrevStep={() => setStep(step - 1)}
                />
            </CSSTransition>
        </>
    )
}

export default Home
